import { useDispatch } from 'react-redux'
import { Box } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { setCancelImportDialog, useImportCSVData } from 'app/store/importCSV'

import CircularProgressWithLabel from './CircularProgressWithLabel'
import { CANCEL_IMPORT_CSV } from '../constansts'

import useStyles from './styles'

export default function LoadingProgress({ showPercent = true, percent, text }) {
  const classes = useStyles()
  const dispatch = useDispatch()

  const cancelUploadOrImport = () => {
    dispatch(setCancelImportDialog(CANCEL_IMPORT_CSV))
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      mt={'100px'}
    >
      <CircularProgressWithLabel value={percent} showPercent={showPercent} />
      <p className={classes.title}>{text}</p>
      <p className={classes.dedescription}>
        <FormattedMessage id={'subscribers.import.progressBar.text2'} />
      </p>

      <p className={classes.cancelUploadBtn} onClick={cancelUploadOrImport}>
        <FormattedMessage id={'subscribers.import.progressBar.text4'} />
      </p>
    </Box>
  )
}
